import clevertapTracking from "@/libs/clevertapTracking";
import {
  AssetClickedInterface,
  ButtonClickedInterface,
  DateAddedInterface,
  LoginDoneInterface,
  PageViewInterface,
  PopupViewedInterface,
} from "@/helpers/TSDEvents/interfaces";
import { CONTENT_PAGES, EVENT_NAMES } from "@/helpers/constants";

export const pageViewEvent = (props: PageViewInterface) => {
  const getEventName = (page) => {
    if (!CONTENT_PAGES.includes(page)) {
      const pageEvents = {
        home: EVENT_NAMES["HOME_PAGE_VIEWED"],
        category: EVENT_NAMES["CATEGORY_PAGE_VIEWED"],
        pillar: EVENT_NAMES["PILLAR_PAGE_VIEWED"],
        cluster: EVENT_NAMES["CLUSTER_PAGE_VIEWED"],
      };

      return pageEvents[page] || "";
    } else {
      return EVENT_NAMES["CONTENT_VIEWED"];
    }
  };

  const { page, ...rest } = props;
  clevertapTracking(getEventName(page), rest);
};

export const assetClickedEvent = (props: AssetClickedInterface) => {
  const { asset_name, asset_display_text, momverse_stage, asset_position, ...rest } = props;

  clevertapTracking(EVENT_NAMES["ASSET_CLICKED"], {
    asset_name,
    asset_display_text,
    momverse_stage,
    asset_position,
    ...rest,
  });
};

export const buttonClickedEvent = (props: ButtonClickedInterface) => {
  const { button_name, momverse_stage, is_loggedin, ...rest } = props;

  clevertapTracking(EVENT_NAMES["BUTTON_CLICKED"], {
    button_name,
    momverse_stage,
    is_loggedin,
    ...rest,
  });
};

export const popupViewedEvent = (props: PopupViewedInterface) => {
  const { popup_name, momverse_stage, popup_position, ...rest } = props;

  clevertapTracking(EVENT_NAMES["POPUP_VIEWED"], {
    popup_name,
    momverse_stage,
    popup_position,
    ...rest,
  });
};

export const dateAddedEvent = (props: DateAddedInterface) => {
  const { action, momverse_stage, date_type, ...rest } = props;

  clevertapTracking(EVENT_NAMES["DATE_ADDED"], {
    action,
    momverse_stage,
    date_type,
    ...rest,
  });
};

export const loginDoneEvent = (props: LoginDoneInterface) => {
  const { mobile, platform, is_new_user, gender, ...rest } = props;

  clevertapTracking(is_new_user ? EVENT_NAMES["REGISTRATION_DONE"] : EVENT_NAMES["LOGIN_DONE"], {
    mobile,
    platform,
    gender,
    ...rest,
  });
};
